
export class Video {
  public VideoId = '';
  public VideoCNDUrl = '';
  public VideoHomeTeamId = '';
  public VideoHomeTeamName = '';
  public VideoHomeTeamScore = '';
  public VideoAwayTeamId = '';
  public VideoAwayTeamName = '';
  public VideoAwayTeamScore = '';
  public VideoDateTime = '';
  public VideoEventStartDate = '';
  public VideoActionTime = '';
  public VideoHighlightsId = '';
  public VideoGameId = '';
  public VideoEventName = '';
  public VideoCanBePlayed = false;
  public VideoSubtitle = '';
  public VideoTag = '';
  public VideoThumbnailUrl = '';
  public VideoType = '';
  public VideoTitle = '';
  public VideoUrl = '';
  public VideoYoutubeUrl = '';

  constructor() { }

  public static parse(data: any): Video {
    const video = new Video();

    if (data) {
      if (data.VideoId) {
        video.VideoId = data.VideoId;
      }
      if (data.VideoCNDUrl) {
        video.VideoCNDUrl = data.VideoCNDUrl;
      }
      if (data.VideoHomeTeamId || data.VideoEquipoLocatarioId) {
        video.VideoHomeTeamId = data.VideoHomeTeamId || data.VideoEquipoLocatarioId;
      }
      if (data.VideoHomeTeamName || data.VideoEquipoLocatarioNombre) {
        video.VideoHomeTeamName = data.VideoHomeTeamName || data.VideoEquipoLocatarioNombre;
      }
      if (data.VideoHomeTeamScore || data.VideoEquipoLocatarioScore) {
        video.VideoHomeTeamScore = data.VideoHomeTeamScore || data.VideoEquipoLocatarioScore;
      }
      if (data.VideoAwayTeamId || data.VideoEquipoVisitanteId) {
        video.VideoAwayTeamId = data.VideoAwayTeamId || data.VideoEquipoVisitanteId;
      }
      if (data.VideoAwayTeamName || data.VideoEquipoVisitanteNombre) {
        video.VideoAwayTeamName = data.VideoAwayTeamName || data.VideoEquipoVisitanteNombre;
      }
      if (data.VideoAwayTeamScore || data.VideoEquipoVisitanteScore) {
        video.VideoAwayTeamScore = data.VideoAwayTeamScore || data.VideoEquipoVisitanteScore;
      }
      if (data.VideoDateTime || data.VideoFechaHora) {
        video.VideoDateTime = data.VideoDateTime || data.VideoFechaHora;
      }
      if (data.VideoEventStartDate || data.VideoFechaInicioEvento) {
        video.VideoEventStartDate = data.VideoEventStartDate || data.VideoFechaInicioEvento;
      }
      if (data.VideoActionTime || data.VideoHoraAccion) {
        video.VideoActionTime = data.VideoActionTime || data.VideoHoraAccion;
      }
      if (data.VideoHighlightsId || data.VideoIdHighlights) {
        video.VideoHighlightsId = data.VideoHighlightsId || data.VideoIdHighlights;
      }
      if (data.VideoGameId || data.VideoIdJuego) {
        video.VideoGameId = data.VideoGameId || data.VideoIdJuego;
      }
      if (data.VideoEventName || data.VideoNombreEvento) {
        video.VideoEventName = data.VideoEventName || data.VideoNombreEvento;
      }
      if (data.VideoSubtitle || data.VideoSubTitulo) {
        video.VideoSubtitle = data.VideoSubtitle || data.VideoSubTitulo;
      }
      if (data.VideoTag) {
        video.VideoTag = data.VideoTag;
      }
      if (data.VideoThumbnailUrl || data.VideoThumbnailUrl) {
        video.VideoThumbnailUrl = data.VideoThumbnailUrl || data.VideoThumbnailUrl;
      }
      if (data.VideoType || data.VideoTipo) {
        video.VideoType = data.VideoType || data.VideoTipo;
      }
      if (data.VideoTitle || data.VideoTitulo) {
        video.VideoTitle = data.VideoTitle || data.VideoTitulo;
      }
      if (data.VideoCanBePlayed || data.VideoPuedeReproducir) {
        video.VideoCanBePlayed = data.VideoCanBePlayed || data.VideoPuedeReproducir;
      } else {
        if (video.VideoTitle) {
          video.VideoTitle += ' (Premium ⭐)';
        }
      }
      if (data.VideoUrl || data.VideoUrl) {
        video.VideoUrl = data.VideoUrl || data.VideoUrl;
      }
      if (data.VideoYoutubeUrl || data.VideoYoutubeUrl) {
        video.VideoYoutubeUrl = data.VideoYoutubeUrl || data.VideoYoutubeUrl;
      }
    }

    return video;
  }
}
